module.exports = __webpack_public_path__ + "static/img/1.b8106c1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phoneCloseCM/cpxh/1.jpg
// module id = jsce
// module chunks = 0